// src/components/resources/ResourceGridSkeleton.tsx

import { cn } from '~/lib/utils'

interface ResourceGridSkeletonProps {
  type?: 'default' | 'featured' | 'compact'
  count?: number
}

export function ResourceGridSkeleton({
  type = 'default',
  count = 6
}: ResourceGridSkeletonProps): JSX.Element {
  const gridConfig = {
    default: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8',
    featured: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8',
    compact: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6'
  }

  return (
    <div className={cn("grid", gridConfig[type])}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="flex flex-col space-y-4"
        >
          {/* Image Skeleton */}
          <div className="relative aspect-[16/9] w-full overflow-hidden rounded-xl bg-gray-200 dark:bg-gray-800 animate-pulse" />
          
          {/* Content Skeleton */}
          <div className="space-y-3">
            <div className="h-6 w-3/4 rounded-md bg-gray-200 dark:bg-gray-800 animate-pulse" />
            <div className="h-4 w-full rounded-md bg-gray-200 dark:bg-gray-800 animate-pulse" />
            <div className="h-4 w-2/3 rounded-md bg-gray-200 dark:bg-gray-800 animate-pulse" />
          </div>

          {/* Metadata Skeleton */}
          <div className="flex items-center justify-between pt-4">
            <div className="flex gap-2">
              <div className="h-6 w-16 rounded-full bg-gray-200 dark:bg-gray-800 animate-pulse" />
              <div className="h-6 w-16 rounded-full bg-gray-200 dark:bg-gray-800 animate-pulse" />
            </div>
            <div className="h-5 w-5 rounded-full bg-gray-200 dark:bg-gray-800 animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  )
}